import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { languageService } from '@unpispas/upp-base';
import { dataService } from '@unpispas/upp-data';
import { i18nSupport } from '@unpispas/upp-data';
import { ViewRenderer } from '@unpispas/upp-wdgt';
import { viewService } from '@unpispas/upp-base';

import { OfferView } from '@unpispas/upp-data';
import { DiscountView } from '@unpispas/upp-data';

@Component({
    selector: 'upp-offer-thumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-thumb.html',
    styleUrls: [
      './upp-thumb.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppOfferThumbComponent extends i18nSupport implements OnChanges, OnDestroy {
    @Input() item: OfferView | DiscountView | null = null;

    @Output() Select = new EventEmitter <OfferView | DiscountView | null> ();

    private _offer_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }

    ngOnChanges(){
        if (this._offer_subscription){
            this._offer_subscription.unsubscribe();
            this._offer_subscription = null;
        }

        if (this.item){
            this._offer_subscription = this.item.OnViewRefresh.subscribe(
            () => {
                this.change.markForCheck();
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._offer_subscription){
            this._offer_subscription.unsubscribe();
            this._offer_subscription = null;
        }
    }

    /********************************/
    /* EVENT HANDLERS               */
    /********************************/

    OnSelect(){
        this.Select.emit(this.item);
    }
}